import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const PartnerFallback = () => {
    return (
        <HeaderFallback title="همراهان آقای پرداخت">
            <Card sx={{ width: { xs: '100%', sm: '48%' }, maxWidth: '335px' }}>
                <CardContent>
                    <Box
                        sx={{
                            m: 2,
                            mb: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                        <img
                            src="/images/no-exist.png"
                            alt="همکار آقای پرداخت"
                            style={{
                                width: '80px',
                                height: '80px',
                                borderRadius: '20px',
                            }}
                        />

                        <Skeleton
                            variant="text"
                            width={170}
                            sx={{ mt: 2, mr: 0.5, fontSize: 18 }}
                        />

                        <Skeleton
                            width={88}
                            sx={{ mt: 2, mr: 0.5, fontSize: 14 }}
                        />
                    </Box>

                    <>
                        <Typography
                            variant="body1"
                            sx={{
                                width: '100%',
                                textAlign: 'center',
                                fontSize: 14,
                                mt: 1,
                            }}>
                            <Skeleton variant="rectangular" height={42} />
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                overflow: 'hidden',
                                border: 1,
                                borderColor: 'border.main',
                                borderRadius: 3,
                                mt: 2,
                                py: 1.5,
                                px: 2,
                                gap: 1,
                            }}>
                            <Box
                                sx={{
                                    borderRight: 1,
                                    borderColor: 'border.main',
                                    p: '4px 8px 4px 0px',
                                    font: '12px',
                                }}>
                                <Skeleton width={49} />
                            </Box>

                            <Skeleton width={56} />

                            <Box
                                sx={{
                                    borderLeft: 1,
                                    borderColor: 'border.main',
                                    p: '4px 0px 4px 8px',
                                    font: '12px',
                                }}>
                                <Skeleton width={55} />
                            </Box>
                        </Box>
                    </>
                </CardContent>
            </Card>
        </HeaderFallback>
    );
};

export default PartnerFallback;
